import { render, staticRenderFns } from "./Personal_registration.vue?vue&type=template&id=0de26498&scoped=true&"
import script from "./Personal_registration.vue?vue&type=script&lang=js&"
export * from "./Personal_registration.vue?vue&type=script&lang=js&"
import style0 from "./Personal_registration.vue?vue&type=style&index=0&id=0de26498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de26498",
  null
  
)

export default component.exports